module.exports = __webpack_public_path__ + "static/assets/bb7c6671cf8cdffe1001dc509d20881c.svg";